import { gsap, ScrollTrigger } from "gsap/all";
import {TweenMax} from "gsap";
gsap.registerPlugin(ScrollTrigger, TweenMax); 


import '../sass/main.scss';

import {navTl, navIcon, allLinks, socialLinks} from './customer';

